import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TEventLogObject } from "../../../../services/api/instances/researchApi/types";
import { AppLoading } from "../../../../shared/components/AppLoading";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { EventMessage } from "./Components/EventMessage";
import { EventProgress } from "./Components/EventProgress";
import { EventStatus } from "./Components/EventStatus";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";

export const EventLog = () => {
  const { selectedId, selectedObject } = useStorageSelectors("research");
  const { t } = useTranslation();

  const logs = useMemo(() => {
    return selectedObject?.value?.research_object?.event_log;
  }, [selectedObject?.value?.research_object?.event_log, selectedId]);

  const isActiveTask = useMemo(() => {
    return selectedObject?.value?.research_object?.run_id ? true : false;
  }, [selectedObject?.value?.research_object?.run_id, selectedId]);

  return (
    <div className={styles.container}>
      <AppUnderlinedTitle leftContent={t("research.event_log")}>
        {isActiveTask && <AppLoading settingSize={16} />}
      </AppUnderlinedTitle>
      <div className={styles["logs-container"]}>
        {logs && (
          <>
            <EventStatus isResearching={isActiveTask ?? false} />
            <EventProgress
              event={logs as TEventLogObject}
              isResearching={isActiveTask ?? false}
            />
            <EventMessage messages={logs.messages ?? []} />
          </>
        )}
      </div>
    </div>
  );
};
